import Image from 'next/future/image';
import sustainableIcon from '@/public/icons/collection/sustainable.svg';

const SustainableBadge = () => (
  <div className="flex items-center gap-1.5 rounded-md bg-[#ECFCF5] px-3 py-1.5 text-xs text-[#1D6C49]">
    <div className="h-3.5 w-3.5 shrink-0">
      <Image
        alt="Sustainable"
        src={sustainableIcon}
        className="h-full w-full"
      />
    </div>
    Sustainable <span className="hidden xxs:inline-block">choice</span>
  </div>
);

export default SustainableBadge;
